export const GRAPHQL_RECONNECTED_EVENT = "comedor-graphql-reconnected";

// La conexión inicial ya carga los datos. Una reconexión necesita recuperar
// los cambios cuyos eventos se perdieron mientras el WebSocket estaba caído.
export const createGraphqlConnectionHandler = () => {
  let connectedBefore = false;
  return () => {
    const isReconnect = connectedBefore;
    connectedBefore = true;
    if (isReconnect) {
      window.dispatchEvent(new Event(GRAPHQL_RECONNECTED_EVENT));
    }
  };
};
